import React from "react";
const Gallery = () => {
  return (
    <div>
      <h1>Gallery Page</h1>
    </div>
  );
};
export default Gallery;
